export class ConfigService {
    getBusinessVersion() {
        return process.env.REACT_APP_VERSION;
    }

    getReCaptchaToken() {
        return process.env.REACT_APP_KEY_GOOGLE_CAPTCHA;
    }
}